export const FLIP = '[cards] flip';
export const CLEAR_FLIPPED = '[cards] clear flipped';
export const NO_MATCH = '[cards] no match';
export const MATCH = '[cards] match';
export const CHANGE_BACK = '[cards] change card back';
